export const filterTickes = (items, terms) => {
    // eslint-disable-next-line array-callback-return
    return items.filter((item) => {
      const first=  item.segments[0].stops.length
      const second = item.segments[1].stops.length
      if (terms.includes(first) && terms.includes(second)) {
        return item
      }
    } )
  }